<template>
  <div class="md-layout">
    <md-divider class="md-inset"></md-divider>

    <div class="md-layout-item md-size-100 md-layout md-alignment-center-left">
      <h4 class="md-layout-item md-size-25 md-small-size-50">Agregar concepto</h4>

      <div class="md-layout-item md-size-50">
        <label>Buscar por</label>
        <md-radio v-model="searchByName" :value="true">Nombre</md-radio>

        <md-radio v-model="searchByName" :value="false">Código</md-radio>
      </div>
    </div>

    <div class="md-layout-item md-size-100 md-layout">
      <multiselect
        class="md-layout-item md-size-50"
        :options="selectableConcepts"
        v-model="newConcept"
        track-by="id"
        label="name"
        placeholder="Busque un concepto"
        select-label="Enter para seleccionar"
        @search-change="queryChanged"
        :internal-search="false"
        :loading="loading"
      >
        <template slot="noOptions">{{ noOptionsMessage }}</template>

        <template slot="noResult">No hay resultados</template>

        <div slot-scope="{ option }" slot="option">
          <strong class="concept-title">{{ option.name }}</strong>

          <div class="concept-description">
            <span>
              <strong>Código:</strong>
              {{ option.code }}
            </span>
            <br />

            <span>
              <strong>Precio:</strong>
              {{ option.unitPriceMXN | money }}
            </span>
            <span>
              <strong>Precio Insumos:</strong>
              {{ option.suppliesSum | money }}
            </span>
          </div>
        </div>
      </multiselect>
    </div>
  </div>
</template>

<script>
import purchaseService from "@/services/purchase";
import { throttle } from "lodash";

const NO_RESULTS_MSG = "No hay resultados";
const EMPTY_MESSAGE = "Escriba un termino de busqueda";

export default {
  name: "ConceptSelector",

  props: {
    existantConcepts: {
      type: Array,
      required: true,
    },
    campId: {
      type: Number,
      required: true,
    },
    catalogId: {
      type: Number,
      required: false,
    },
  },

  data() {
    return {
      searchByName: true,
      availableConcepts: [],
      newConcept: null,
      searchQuery: null,
      loading: null,
    };
  },

  computed: {
    selectableConcepts() {
      return this.availableConcepts;
    },
    noOptionsMessage() {
      return this.searchQuery ? NO_RESULTS_MSG : EMPTY_MESSAGE;
    },
  },

  watch: {
    newConcept(value) {
      if (value) {
        this.$emit("conceptAdded", value);
        this.newConcept = null;
      }
    },
    catalogId(value) {
      this.availableConcepts = [];
    },
    campId(value) {
      this.availableConcepts = [];
    },
  },

  methods: {
    addConcept() {
      const newConcept = this.newConcept;
      this.$emit("conceptAdded", newConcept);
      this.newConcept = null;
    },
    queryChanged: throttle(function (query = "") {
      this.searchQuery = query;
      if (query.length < 3) {
        this.loading = false;
        return;
      }
      this.loading = true;
      const searchByName = this.searchByName;
      const { campId: camp, catalogId: catalog } = this;
      purchaseService
        .searchConcept(query, { camp, catalog }, { searchByName })
        .then((concepts) => {
          this.availableConcepts = concepts;
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
        });
    }, 400),
  },
};
</script>

<style lang="css" scoped>
.concept-title {
  font-size: 15px;
}

.concept-description {
  background-color: transparent !important;
  font-size: 13px;
}
</style>



// WEBPACK FOOTER //
// src/pages/RoadSinisters/File/Quantification/ConceptSelector.vue